import dayjs from 'dayjs';

// TODO: Move to date utils!
export const getNext30MinuteInterval = () => {
  const now = dayjs();
  const remainder = 30 - (now.minute() % 30);
  return dayjs(now).add(remainder, 'minutes').format('HH:mm:[00]'); // don't care about seconds, always 00
};
